var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKenya(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_483_31646)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.1967,
    height: 24.1967,
    transform: "translate(0.266602 0.654297)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.365 24.851C19.0467 24.851 24.4633 19.4344 24.4633 12.7526C24.4633 6.07091 19.0467 0.654297 12.365 0.654297C5.68322 0.654297 0.266602 6.07091 0.266602 12.7526C0.266602 19.4344 5.68322 24.851 12.365 24.851Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3649 0.654297C7.56839 0.654297 3.42395 3.44566 1.46704 7.49251H23.2627C21.3059 3.44566 17.1614 0.654297 12.3649 0.654297Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3649 24.8499C7.56839 24.8499 3.42395 22.0586 1.46704 18.0117H23.2627C21.3059 22.0586 17.1614 24.8499 12.3649 24.8499Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.892 9.07031H0.837918C0.467311 10.2314 0.266602 11.4684 0.266602 12.7524C0.266602 14.0364 0.467311 15.2734 0.837918 16.4345H23.8919C24.2626 15.2734 24.4633 14.0364 24.4633 12.7524C24.4633 11.4684 24.2626 10.2314 23.892 9.07031Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1322 6.24528L14.6994 5.58398L12.3649 10.87L10.0304 5.58398L8.59766 6.24528L11.496 12.7528L8.59766 19.2604L10.0304 19.9217L12.3649 14.6357L14.6994 19.9217L16.1322 19.2604L13.2339 12.7528L16.1322 6.24528Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3381 6.86799C12.7834 6.26227 12.365 5.91406 12.365 5.91406C12.365 5.91406 11.9465 6.26222 11.3918 6.86799V18.6365C11.9465 19.2423 12.365 19.5905 12.365 19.5905C12.365 19.5905 12.7834 19.2423 13.3381 18.6365V6.86799Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73486 9.124V16.3788C10.321 17.4174 11.0383 18.2686 11.5759 18.833V6.66992C11.0383 7.23424 10.3209 8.08552 9.73486 9.124Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9949 9.124C14.4087 8.08548 13.6914 7.23424 13.1538 6.66992V18.833C13.6914 18.2686 14.4087 17.4174 14.9949 16.3788V9.124Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9951 9.125V16.3799C15.5885 15.3284 16.0472 14.085 16.0472 12.7525C16.0472 11.4199 15.5885 10.1765 14.9951 9.125Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7349 9.125V16.3799C9.14156 15.3284 8.68286 14.085 8.68286 12.7525C8.68286 11.4199 9.14156 10.1765 9.7349 9.125Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_483_31646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.1967,
    height: 24.1967,
    fill: "white",
    transform: "translate(0.266602 0.654297)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKenya);
export default __webpack_public_path__ + "static/media/Kenya.fc182dbd7105e991c1367c6f9f5d93e4.svg";
export { ForwardRef as ReactComponent };